import React, { Component } from "react";
import { connect } from "react-redux";
import { PageHeader, Spin, Tabs, message } from "antd";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";

import { ButtonItem } from "../../../../Components/Items";
import ModalPrevisualizarArchivos from "../../../../Components/ModalPrevisualizarArchivos";
import SolicitarCotizacion from "./SolicitarCotizacion";
import ModalEnviarSolicitud from "./ModalEnviarSolicitud";
import ModalCargarCotizacion from "./ModalCargarCotizacion";
import CotizacionesRecibidas from "./CotizacionesRecibidas";
import ComparativoCotizaciones from "./ComparativoCotizaciones";

moment.locale("es");

const { TabPane } = Tabs;

/**
 * Pantalla de Solicitudes/Cotizaciones de una Requisicion.
 *
 * Se llega desde el boton "Solicitud de Cotización" de la tabla de Requisiciones, con el
 * id en location.state (mismo patron que MandarWorkBench y GenerarOrdenDeCompra).
 */
class CotizacionesRequisicion extends Component {
  state = {
    loading: false,
    requisicion: null,
    insumos: [],
    empresa: null,
    logoBiwo: null,
    usuario: null,
    proyecto: null,
    proveedoresSugeridos: [],
    cotizaciones: [],
    tabActiva: "solicitar",

    modalEnviar: false,
    envioComun: null,
    envioSolicitudes: [],

    modalCargar: false,
    cotizacionCargar: null,

    modalArchivo: false,
    archivoVer: null,
    archivoCotizacionId: null,
  };

  componentDidMount() {
    if (!this.props.location?.state?.id) {
      message.error("No se recibió la requisición");
      this.props.history.push("/panel/requisiciones");
      return;
    }
    this.consultarTodo();
  }

  get requisicionId() {
    return this.props.location?.state?.id;
  }

  consultarTodo = async () => {
    this.setState({ loading: true });
    try {
      const [resDatos, resCotizaciones] = await Promise.all([
        axios.post(
          "cotizacionesRequisicion/datosSolicitud",
          { empresaId: this.props.empresaId, requisicionId: this.requisicionId },
          { headers: this.props.headersToken }
        ),
        axios.post(
          "cotizacionesRequisicion/selectCotizacionesRequisicion",
          { empresaId: this.props.empresaId, requisicionId: this.requisicionId },
          { headers: this.props.headersToken }
        ),
      ]);

      if (resDatos.data.success !== 2) {
        message.error(resDatos.data.message || "No se pudo cargar la requisición");
        this.setState({ loading: false });
        return;
      }

      this.setState({
        loading: false,
        requisicion: resDatos.data.requisicion,
        insumos: resDatos.data.insumos || [],
        empresa: resDatos.data.empresa,
        logoBiwo: resDatos.data.logoBiwo,
        usuario: resDatos.data.usuario,
        proyecto: resDatos.data.proyecto,
        proveedoresSugeridos: resDatos.data.proveedoresSugeridos || [],
        cotizaciones:
          resCotizaciones.data.success === 2 ? resCotizaciones.data.cotizaciones : [],
      });
    } catch (err) {
      console.error(err);
      message.error("Sucedió un error y no se pudo cargar la información");
      this.setState({ loading: false });
    }
  };

  consultarCotizaciones = async () => {
    try {
      const res = await axios.post(
        "cotizacionesRequisicion/selectCotizacionesRequisicion",
        { empresaId: this.props.empresaId, requisicionId: this.requisicionId },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) this.setState({ cotizaciones: res.data.cotizaciones });
    } catch (err) {
      console.error(err);
    }
  };

  onSolicitudesGeneradas = (comun, solicitudes) => {
    this.setState({
      modalEnviar: true,
      envioComun: comun,
      envioSolicitudes: solicitudes,
    });
    this.consultarCotizaciones();
  };

  cerrarModalEnviar = () => {
    this.setState({ modalEnviar: false, envioComun: null, envioSolicitudes: [] });
  };

  abrirModalCargar = (cotizacion) => {
    this.setState({ modalCargar: true, cotizacionCargar: cotizacion || null });
  };

  cerrarModalCargar = () => {
    this.setState({ modalCargar: false, cotizacionCargar: null });
  };

  onCotizacionGuardada = () => {
    this.cerrarModalCargar();
    this.consultarCotizaciones();
    this.setState({ tabActiva: "cotizaciones" });
  };

  verArchivo = (cotizacionId, archivo) => {
    this.setState({
      modalArchivo: true,
      archivoCotizacionId: cotizacionId,
      archivoVer: {
        name: archivo.name,
        cargadoDesdeBackend: true,
        urlRelativa: archivo.url,
      },
    });
  };

  render() {
    const {
      loading,
      requisicion,
      insumos,
      empresa,
      logoBiwo,
      usuario,
      proyecto,
      proveedoresSugeridos,
      cotizaciones,
      tabActiva,
    } = this.state;

    return (
      <>
        <PageHeader
          title={
            requisicion
              ? `Cotizaciones de la Requisición ${requisicion.numero}`
              : "Cotizaciones de Requisición"
          }
          subTitle={
            requisicion?.fechaEntrega
              ? `Entrega: ${moment(requisicion.fechaEntrega).format("DD/MM/YYYY")}`
              : undefined
          }
          onBack={() => this.props.history.goBack()}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <ButtonItem type="primary" onClick={() => this.abrirModalCargar(null)}>
              Cargar Cotización
            </ButtonItem>
          }
        />
        <Spin spinning={loading}>
          <div style={{ backgroundColor: "white", padding: 15 }}>
            <Tabs
              activeKey={tabActiva}
              onChange={(tab) => this.setState({ tabActiva: tab })}
            >
              <TabPane tab="Solicitar" key="solicitar">
                {requisicion && (
                  <SolicitarCotizacion
                    empresaId={this.props.empresaId}
                    headersToken={this.props.headersToken}
                    requisicion={requisicion}
                    insumos={insumos}
                    empresa={empresa}
                    logoBiwo={logoBiwo}
                    usuario={usuario}
                    proyecto={proyecto}
                    proveedoresSugeridos={proveedoresSugeridos}
                    onSolicitudesGeneradas={this.onSolicitudesGeneradas}
                  />
                )}
              </TabPane>
              <TabPane tab={`Cotizaciones (${cotizaciones.length})`} key="cotizaciones">
                <CotizacionesRecibidas
                  empresaId={this.props.empresaId}
                  headersToken={this.props.headersToken}
                  cotizaciones={cotizaciones}
                  onCargar={this.abrirModalCargar}
                  onVerArchivo={this.verArchivo}
                  onActualizar={this.consultarCotizaciones}
                />
              </TabPane>
              <TabPane tab="Comparativo" key="comparativo">
                <ComparativoCotizaciones insumos={insumos} cotizaciones={cotizaciones} />
              </TabPane>
            </Tabs>
          </div>
        </Spin>

        <ModalEnviarSolicitud
          visible={this.state.modalEnviar}
          onCancel={this.cerrarModalEnviar}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          comun={this.state.envioComun}
          solicitudes={this.state.envioSolicitudes}
          onEnviado={() => {
            this.cerrarModalEnviar();
            this.consultarCotizaciones();
          }}
        />

        <ModalCargarCotizacion
          visible={this.state.modalCargar}
          onCancel={this.cerrarModalCargar}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          requisicionId={this.requisicionId}
          insumos={insumos}
          cotizacion={this.state.cotizacionCargar}
          proveedoresSugeridos={proveedoresSugeridos}
          onGuardado={this.onCotizacionGuardada}
        />

        <ModalPrevisualizarArchivos
          visible={this.state.modalArchivo}
          file={this.state.archivoVer}
          onCancel={() => this.setState({ modalArchivo: false, archivoVer: null })}
          endpointArchivo="cotizacionesRequisicion/obtenerArchivoCotizacionBase64"
          parametrosArchivo={{ cotizacionId: this.state.archivoCotizacionId }}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(CotizacionesRequisicion);
